import { render, staticRenderFns } from "./AuthorizeForm.vue?vue&type=template&id=2ecd8dca&"
import script from "./AuthorizeForm.vue?vue&type=script&lang=js&"
export * from "./AuthorizeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ecd8dca')) {
      api.createRecord('2ecd8dca', component.options)
    } else {
      api.reload('2ecd8dca', component.options)
    }
    module.hot.accept("./AuthorizeForm.vue?vue&type=template&id=2ecd8dca&", function () {
      api.rerender('2ecd8dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/layout/AuthorizeForm.vue"
export default component.exports